/**
 * Verifies that a property exists in client app config and has a valid value.
 */
export function isValidClientAppConfigProperty(config: Record<string, unknown>, property: keyof typeof config) {
  if (property in config) {
    return config[property] !== undefined && config[property] !== null && config[property] !== '';
  }

  return false;
}
